import React, { Component } from "react";

import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import {
  sortNumeric,
  selectFormat,
  Error,
  getMetricForColumn,
  TableContentCell,
} from "components/Utils/Utils";
import paginationFactory from "react-bootstrap-table2-paginator";
import filterFactory, { textFilter } from "react-bootstrap-table2-filter";

class SocialTopPerformingPosts extends Component {
  componentDidMount() {
    this.props.childRef(this);
  }

  renderTable(data) {
    const { cells, title } = this.props;

    // add unique ids
    data.forEach((d, i) => {
      d.id = i;
    });

    const columns = [
      {
        dataField: "title",
        text: "Title",
        classes: "sticky-column",
        headerClasses: "sticky-column",
        style: { width: "420px", minWidth: "420px", textAlign: "left" },
        headerAlign: "left",
        formatter: TableContentCell,
        csvFormatter: (cell, row) => cell,
        sort: true,
        filter: textFilter({
          getFilter: (filter) => filter,
          placeholder: " ",
          className: "custom-table-filter-input",
          caseSensitive: false,
        }),
      },
      {
        dataField: "post_type",
        text: "Post Type",
        style: { width: "80px", minWidth: "100px", textAlign: "left" },
        headerAlign: "left",
        csvFormatter: (cell, row) => row.post_type,
        sort: true,
        filter: textFilter({
          getFilter: (filter) => filter,
          placeholder: " ",
          className: "custom-table-filter-input",
          caseSensitive: false,
        }),
      },
      {
        dataField: "post_date",
        text: "Publish Date",
        style: { width: "80px", minWidth: "100px" },
        formatter: (cell, row) => selectFormat("date", cell),
        csvFormatter: (cell) => {
          if (cell) {
            return selectFormat("date", cell);
          }
        },
        sort: true,
        sortFunc: (a, b, order) =>
          order === "desc" ? (a > b ? 1 : -1) : b > a ? 1 : -1,
      },
      {
        dataField: "account_name",
        text: "Handle",
        style: { width: "120px", minWidth: "120px", textAlign: "left" },
        headerAlign: "left",
        csvFormatter: (cell, row) => row.account_name,
        sort: true,
        filter: textFilter({
          getFilter: (filter) => filter,
          placeholder: " ",
          className: "custom-table-filter-input",
          caseSensitive: false,
        }),
      },
      {
        dataField: "reach",
        text: "Ltd Reach",
        style: { width: "100px", minWidth: "100px" },
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "engagements",
        text: "Ltd Engagements",
        style: { width: "100px", minWidth: "120px" },
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "views",
        text: "Ltd Views",
        style: { width: "100px", minWidth: "100px" },
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "impressions",
        text: "Ltd Impressions",
        style: { width: "100px", minWidth: "120px" },
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "engagement_rate",
        text: "Eng Rate",
        style: { width: "90px", minWidth: "90px" },
        formatter: getMetricForColumn,
        formatExtraData: { type: "percentage" },
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0.000%"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "video_view_rate",
        text: "View Rate",
        style: { width: "90px", minWidth: "90px" },
        formatter: getMetricForColumn,
        formatExtraData: { type: "percentage" },
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0.000%"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "video_completion_rate",
        text: "View Completion Rate",
        style: { width: "180px", minWidth: "180px" },
        formatter: getMetricForColumn,
        formatExtraData: { type: "percentage" },
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0.000%"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "url",
        text: "Post URL",
        style: { width: "80px", minWidth: "80px", textAlign: "left" },
        headerAlign: "left",
        csvFormatter: (cell, row) => row.url,
        sort: true,
        hidden: true,
        formatter: (cell, row, rowIndex) =>
          TableContentCell(cell, row, rowIndex, {
            showAsLink: true,
            defaultTitle: "Link",
          }),
      },
      // {
      //   dataField: "post_time",
      //   text: "Publish Time",
      //   style: { width: "80px", minWidth: "100px" },
      //   formatter: (cell, row) => selectFormat("time", cell),
      //   csvFormatter: (cell) => {
      //     if (cell) {
      //       return selectFormat("time", cell);
      //     }
      //   },
      //   sort: true,
      //   sortFunc: (a, b, order) =>
      //     order === "desc" ? (a > b ? 1 : -1) : b > a ? 1 : -1,
      // },
      // {
      //   dataField: "post_hashtags",
      //   text: "Hashtags",
      //   style: { width: "120px", minWidth: "120px", textAlign: "left" },
      //   headerAlign: "left",
      //   csvFormatter: (cell, row) => cell,
      //   sort: true,
      // },
      {
        dataField: "complete_views",
        text: "Complete Views",
        style: { width: "100px", minWidth: "120px" },
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },

      // {
      //   dataField: "impressions_per_1k",
      //   text: "Impressions Per 1k",
      //   style: { width: "90px", minWidth: "130px" },
      //   formatter: getMetricForColumn,
      //   csvFormatter: (cell) =>
      //     selectFormat("csv_number", cell && cell.value, "0,0"),
      //   sort: true,
      //   sortFunc: sortNumeric,
      // },
      // {
      //   dataField: "engagements_per_1k",
      //   text: "Engagements Per 1k",
      //   style: { width: "90px", minWidth: "140px" },
      //   formatter: getMetricForColumn,
      //   csvFormatter: (cell) =>
      //     selectFormat("csv_number", cell && cell.value, "0,0"),
      //   sort: true,
      //   sortFunc: sortNumeric,
      // },

      // {
      //   dataField: "view_rate",
      //   text: "View Rate",
      //   style: { width: "90px", minWidth: "90px" },
      //   formatter: getMetricForColumn,
      //   formatExtraData: { type: "percentage" },
      //   csvFormatter: (cell) =>
      //     selectFormat("csv_number", cell && cell.value, "0.000%"),
      // },
      // {
      //   dataField: "reach_rate",
      //   text: "Reach Rate",
      //   style: { width: "90px", minWidth: "90px" },
      //   formatter: getMetricForColumn,
      //   formatExtraData: { type: "percentage" },
      //   csvFormatter: (cell) =>
      //     selectFormat("csv_number", cell && cell.value, "0.000%"),
      // },
    ];

    const defaultSorted = [
      // {
      //   dataField: defaultSortType,
      //   order: "desc",
      // },
    ];

    let selected_columns = columns;
    if (cells && cells.length) {
      selected_columns = [];
      cells.forEach((cell, i) => {
        selected_columns.push(columns.find((o) => o.dataField === cell));
      });
    }

    const filename = title.split(" ").join("_") || "spreadsheet";

    const pagination = paginationFactory({
      sizePerPage: 5,
      hideSizePerPage: true,
    });

    return (
      <ToolkitProvider
        keyField="id"
        data={data}
        columns={selected_columns}
        striped={false}
        hover={false}
        bordered={false}
        exportCSV={{
          fileName: filename + ".csv",
          exportAll: true,
        }}
      >
        {(props) => (
          <BootstrapTable
            {...props.baseProps}
            {...props.csvProps}
            pagination={pagination}
            defaultSorted={defaultSorted}
            filter={filterFactory()}
            ref={(el) => (this.childRef = el)}
          />
        )}
      </ToolkitProvider>
    );
  }

  builtInExportCSV = () => this.childRef;

  render() {
    const { data } = this.props;

    if (data.hasData === false) {
      return <Error minHeight={360} />;
    }

    return this.renderTable(data.data);
  }
}

export default SocialTopPerformingPosts;
